import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config';
import moment from 'moment';

export default {
  name: 'STDadminRepot',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      todate: '',
      fromdate: '',
      show: false,
      show2: false,
      // for hun list
      hub: '',
      hublist: [],
      // for status list
      Status: '',
      StatusList: [],
      // verification Status
      vStatus: '',
      vStatusList: [],
      myStr: '',
      accesszonelist: '',
      parsedata: '',
      isLoading1: false,
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      listUserData: [],
      awbnumber: '',
      awbNumbers: [],
      msg: '',
      error: false,

      // table
      tablehublist: [],
      currenthubname: '',
      originhubname: '',
      finaldestinationname: '',

      // client list
      clienList: [],
      hubdroplist: [],
      editshowtable: false,
      operator: '',
      octroi_MRP: '',
      exportdis: '',
      detended_days_from: '',
      detended_days_to: '',
      currentdateminus180: '',
      currentdate:moment(new Date()).format("YYYY-MM-DD"),
      ListData: [],
      totalcount: 0,
      verification:[],
      imagePathData: '',
      List:[],
      abc: '',
      primaryKey: '',
      imgData: '',
      showModal: false,
      imgData: '',
      pageno: 0,
      ListData: [],
      errormsg: '',
      show1:false,
      link:`https://${awsBucketName.awsBucketName}.s3.ap-southeast-1.amazonaws.com/`

    };
  },
  mounted() {
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);

    this.getzonehubs();
    this.status();
    this.verificationStatus()
    this.verificationStatusName()
  },
  computed: {
    checkDisabled: function () {
      return (this.operator == '') ? true : false;
    },
    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
  },
  methods: {
    getzonehubs() {
      this.show = true;
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getZoneList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.show = false;
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename,
          });
        });
        this.newhublist = finalHubData;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    callHub(newhublist) {
      this.hublist = [];

      this.getHubList(newhublist.id);
      this.hub = '';
      if (newhublist.id != undefined) {
        this.getHubList();
      }
    },

    status() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}status`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const statusdata = [];
        result.data.data.forEach((status) => {
          statusdata.push({
            id: status.statuscode,
            label: status.statusname,
          });
        });
        this.StatusList = statusdata;
      },
        (error) => {
          console.error(error);
        });
    },

    ImageView(awb1, status) {
      this.errormsg = ''
      this.abc = awb1;
      let path = '';
      this.primaryKey = 123;
      // if (status === 17 || status === 13) {
      //   path = `${awsBucketName}/STD/${awb1}`;
      // } else {
      //   path = `${awsBucketName}/${this.primaryKey}${awb1}`;
      // }
      path = `STD/${awb1}`;
      this.input = ({
        key: path,
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}getListObjectFroms3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.List = result.data.data.Contents;
        if (this.List.length <= 0) {
          this.errormsg = "No Image Found"
        }
      });
    },

    downloadImage(filePath) {
      this.show1 = true;
      this.input = ({
        key: filePath,
        fileName: 'download.png',
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show1 = false;
        //console.log('result from fetch api', result);
        const finalImage = result.data.ImageData.Body.data;
        let buff = new Buffer.from(finalImage);
        let base64data = buff.toString('base64');
        this.imgData = 'data:image/png;base64,' + base64data
      });


      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },
    getHubList(id) {
      const finalhublist = [];
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id == this.parsedata.hubaccess[i].HubZoneId) {
          finalhublist.push({
            id: this.parsedata.hubaccess[i].HubID,
            label: this.parsedata.hubaccess[i].HubName,
          });
          this.hublist = finalhublist;
        }
      }
    },
    verificationStatus() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.vStatusList = vstatusdata
      },
        error => {

          console.error(error)
        })

    },
    resetForm() {
      this.Status = '';
      this.awbnumber='';
      this.vStatus = '';
      this.hub = '';
      this.newhubs = '';
      this.fromdate='';
      this.todate='';
      this.octroi_MRP=''
      this.exportdis = '';
      this.detended_days_from = '',
        this.detended_days_to = '',
        this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
      this.isLoading1 = false;
      this.listUserData = []; this.pageno = 0; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';

    },

    // get client list
    getClientList() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getClientList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.clienList = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {
          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j].clientid !== null
              && this.listUserData[j].clientid != undefined) {
              if (this.clienList[i].ClientMasterID == this.listUserData[j].clientid) {
                this.listUserData[j].Clientname = this.clienList[i].CompanyName;
              }
            }
          }
        }

        this.editshowtable = true;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    getregionname() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j].hubzoneid !== null
            && this.listUserData[j].hubzoneid != undefined) {
            if (this.newhublist[i].id == this.listUserData[j].hubzoneid) {
              this.listUserData[j].regionname = this.newhublist[i].label;
            }
          }
        }
      }

      this.editshowtable = true;
    },
    verificationStatusName() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.verification = vstatusdata
      },
        error => {

          console.error(error)
        })

    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;




        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    // dropdown hub
    gethubdropdown() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getHubdropdownlist`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName,
          });
        });
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].currenthubid !== null
              && this.listUserData[j].currenthubid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].currenthubid) {
                this.listUserData[j].currenthubname = this.hubdroplist[i].label;
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].originhubid !== null
              && this.listUserData[j].originhubid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].originhubid) {
                this.listUserData[j].originhubname = this.hubdroplist[i].label;
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].finaldestinationid !== null
              && this.listUserData[j].finaldestinationid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].finaldestinationid) {
                this.listUserData[j].finaldestinationname = this.hubdroplist[i].label;
              }
            }
          }
        }

        this.editshowtable = true;
      },
        (error) => {
          console.error(error);
        });
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.verification.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.verification[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["lastactionname"] = this.verification[i]["label"];
            }
          }
        }

      }

      this.editshowtable = true;
    },

    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },
    // to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * variables.pageRecordLimit;
      this.searchData(this.pageno);
    },
    // searchbutton
    searchData(pageNo) {
      if ((this.detended_days_from && !this.detended_days_to) || (!this.detended_days_from && this.detended_days_to)) {
        this.$alertify.error("Please enter both Detented Days")

      } else if ((this.detended_days_from && this.detended_days_to) || (!this.detended_days_from && !this.detended_days_to)) {
        this.isLoading1 = true;
        this.show2 = true
        this.listUserData = []; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';
        this.exportdis = 1;
        this.totalcount = 0
        if (this.vStatus.id) {
          var vid = this.vStatus.id;
          var vstatusid = vid.toString();
        }
        if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
          this.$alertify.error("Please enter both  date")

        }
        else if (this.fromdate > this.todate) {
          this.$alertify.error("From date should not be greater than To date")

        } else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {

          var d = new Date();
          let daysto = d.setDate(d.getDate() - 180);
          this.currentdateminus180 = moment(new Date(daysto)).format("YYYY-MM-DD")

          if ((this.fromdate != '' && this.todate != '')) {

            this.input = ({
              offset: pageNo,
              limit: variables.pageRecordLimit,
              shippingid: this.awbnumber,
              FromDate: this.fromdate.slice(0, 10) + " 00:00:00",
              ToDate: this.todate.slice(0, 10) + " 23:59:59",
              status: this.Status.id,
              actionstatuscode: vstatusid,
              detendeddaysfrom: this.detended_days_from,
              detendeddaysto: this.detended_days_to,
              hubzoneid: this.newhubs.id,
              currenthubid: this.hub.id,
              //originhubid: this.hub.id,
              operator: this.operator,
              netvalue: this.octroi_MRP,
            });

          }
          else {
            this.input = ({

              offset: pageNo,
              limit: variables.pageRecordLimit,
              shippingid: this.awbnumber,
              FromDate: this.currentdateminus180.slice(0, 10) + " 00:00:00",
              ToDate: this.currentdate.slice(0, 10) + " 23:59:59",
              status: this.Status.id,
              actionstatuscode: vstatusid,
              detendeddaysfrom: this.detended_days_from,
              detendeddaysto: this.detended_days_to,
              hubzoneid: this.newhubs.id,
              //originhubid: this.hub.id,
              currenthubid: this.hub.id,
              operator: this.operator,
              netvalue: this.octroi_MRP,
            });

          }

          axios({
            method: 'post',
            url: `${apiUrl.api_url}stdadminreport`,
            data: this.input,
            headers: {
              Authorization: `Bearer ${this.myStr}`,
            },
          }).then((result) => {
            this.show2 = false
            this.listUserData = result.data.data;
            this.totalcount = result.data.count?result.data.count:0

            if (this.totalcount == undefined) {
              this.totalcount = 0
            }
            this.getClientList();
            this.gethubdropdown();
            this.getregionname();
            this.Statusname();
            this.buckettypecode();
            this.verificationStatusList()

            if (this.totalcount < variables.pageRecordLimit) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit);
            }
          });
        }//else
      }//else
    },
    exportfileCSV() {
      this.isLoading1 = true;
      this.downloadCSV(this.listUserData);
    },

    async downloadCSV(result) {
      const csvData = result;
      const today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      const todayDate = `${dd}${mm}${yyyy}`;
      let data; let filename; let
        link;
      filename = `stdadminreport${todayDate}.csv`;
      let csv = await this.convertArrayOfObjectsToCSV({
        data: csvData,
      });
      if (csv == null) return;
      filename = filename || 'export.csv';
      if (!csv.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`;
      }
      data = csv;
      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,PendingDays,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString()+ ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ','  + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ','  + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' +data[i].phyweight+ ',' + data[i].volweight + ',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ',' + data[i].pendingdays + ',' + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription +',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby +',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") +',' + data[i].shortagetype +',' + data[i].bagno +',' + data[i].recreasionname   ;

        result += lineDelimiter;


      }
      return result;
    },

  },
};



// WEBPACK FOOTER //
// ./src/views/components/STDAdminReport/STDAdminReport.component.js